import React, { useEffect, useMemo, useState } from 'react';
import styles from '../../assets/styles/Catalogue/Catalogue.module.scss';
import { MimaGridView, MimaText, Searchbar } from '../../components';
import { AnimatePresence, motion } from 'framer-motion';
import { amountFormatter } from '../../utils/utils';
import { ordersStore } from '../../stores';
import ReactPaginate from 'react-paginate';
import constant from '../../utils/constant';

const Catalogue = ({
	goToViewMoreDesign,
	handlePageChange,
	data,
	currentPage,
	setCurrentPage,
	onLimitChange,
	limit,
	setSearchQuery,
	isFetching,
	isLoading,
}) => {
	const tableData = useMemo(() => {
		if (data?.status === constant.Success) {
			return data?.data?.styles || [];
		}
		return [];
	}, [data]);

	const ImageSlideshow = ({
		imageUrls,
		goToViewMoreDesign,
		ordersStore,
		item,
	}) => {
		const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
		const [autoPlay, setAutoPlay] = useState(true);

		useEffect(() => {
			const intervalId = autoPlay && setInterval(handleNextSlide, 4000);
			return () => clearInterval(intervalId);
		}, [autoPlay, currentSlideIndex]);

		const handleNextSlide = () => {
			setCurrentSlideIndex(prevIndex => (prevIndex + 1) % imageUrls.length);
		};

		const handleImageClick = () => {
			goToViewMoreDesign();
			ordersStore.setDesign(item);
		};

		return (
			<div>
				<img
					src={imageUrls[currentSlideIndex]}
					alt="designs"
					onClick={handleImageClick}
					onMouseEnter={() => setAutoPlay(false)}
					onMouseLeave={() => setAutoPlay(true)}
				/>
				<div className={styles.breadCrumbsBox}>
					{imageUrls.map((_, i) => (
						<span
							key={i}
							className={
								currentSlideIndex === i ? styles.breadCrumbs : styles.inActive
							}
							onClick={() => setCurrentSlideIndex(i)}></span>
					))}
				</div>
			</div>
		);
	};

	const tableColumns = [
		{
			header: 'Image',
			accessorKey: 'imageUrls',
			cell: item => {
				const imageUrls = item?.getValue();
				return imageUrls ? (
					<ImageSlideshow
						imageUrls={imageUrls}
						goToViewMoreDesign={goToViewMoreDesign}
						ordersStore={ordersStore}
						item={item}
					/>
				) : (
					<span>N/A</span>
				);
			},
		},
		{
			header: 'Product Name',
			accessorKey: 'name',
		},
		{
			header: 'Selling Price',
			accessorKey: 'sellingPrice',
			cell: item => {
				const sellingPrice = item?.getValue();
				const withOutMaterial = sellingPrice.withoutMaterial;
				const withMaterial = sellingPrice.withMaterial;
				const currencyCode = sellingPrice.currencyCode;
				const formattedWithOutMaterial =
					amountFormatter(currencyCode).format(withOutMaterial);
				const formattedWithMaterial =
					amountFormatter(currencyCode).format(withMaterial);
				const combinedData = `${formattedWithOutMaterial} - ${formattedWithMaterial}`;

				return (
					<span>
						<strong>{sellingPrice ? combinedData : 'N/A'}</strong>
					</span>
				);
			},
		},
	];

	return (
		<div className={styles.container}>
			<div className={styles.container_heading}>
				<div className={styles.container_heading__shape}>
					{data?.data?.styles?.[0]?.business?.tradingName
						?.charAt(0)
						.toUpperCase()}
				</div>
				<MimaText variant="subtitleBold" color="var(--color-white)">
					{data?.data?.styles?.[0].business.tradingName}
				</MimaText>
			</div>

			<MimaGridView
				tableData={tableData}
				tableColumns={tableColumns}
				searchPlaceholder="Search Design"
				searchVariant="wide"
				totalItems={data?.data?.totalCount}
				onLimitChange={onLimitChange}
				isLoading={isLoading}
				isFetching={isFetching}
				limit={limit}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
				setSearchQuery={setSearchQuery}
				emptyMessage="No products have been added in this market or match the search criteria."
			/>
		</div>
	);
};

export default Catalogue;
